import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { addSupplier } from "services/createServices";
import axios from "axios";
import { baseUrl } from "utils/api";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

export default function EditCustomer() {
  let { id } = useParams();
  const token = localStorage.getItem("token");
  const history = useHistory();
  const [customer, setCustomer] = useState({});
  const [err, setErr] = useState({});
  const { addToast } = useToasts();

  const getCustomer = async () => {
    var config = {
      method: "get",
      url: `${baseUrl}customer/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    await axios(config)
      .then(function (response) {
        const { data } = response.data;
        setCustomer(data.customer);
      })
      .catch(function (error) {
        return error;
      });
  };

  const editCustomer = async () => {
    var config = {
      method: "put",
      url: `${baseUrl}customer`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: customer,
    };

    await axios(config)
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          history.push("/admin/file-maintainance/customers");
          addToast("Successfully updated customer details", {
            appearance: "success",
            autoDismiss: true,
          });
        }
      })
      .catch(function (error) {
        addToast(`${error.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
        return error;
      });
  };

  useEffect(() => {
    getCustomer();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setCustomer({ ...customer, [name]: value });
  };

  const handleValidation = () => {
    let formIsValid = true;
    let errors = {};

    if (!customer.name) {
      errors.name = "Customer name Cannot empty";
      formIsValid = false;
    }

    if (!customer.code) {
      errors.code = "Customer code Cannot empty";
      formIsValid = false;
    }

    setErr(errors);
    return formIsValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log(customer);
      //   await editCustomer();
    } else {
      addToast("Missing fields", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  return (
    <>
      <div
        className="break-words border-0"
        style={{ minHeight: "520px", paddingTop: "4rem" }}
      >
        <div
          className="flex flex-col shadow-lg rounded-lg "
          style={{ margin: "3rem" }}
        >
          <div
            className="rounded-t bg-white mb-0 px-6 py-6"
            style={{ background: "#9CA3AF" }}
          >
            <div>
              <h6 className="text-gray-800 text-xl font-bold">Edit Customer</h6>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Link
                  to="/admin/dashboard"
                  className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
                >
                  DASHBOARD
                </Link>
                <ArrowForwardIosIcon
                  style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
                />
                <Link
                  to="/admin/file-maintainance"
                  className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
                >
                  FILE MAINTAINANCE
                </Link>
                <ArrowForwardIosIcon
                  style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
                />
                <Link
                  to="/admin/file-maintainance/customers"
                  className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
                >
                  CUSTOMERS
                </Link>
                <ArrowForwardIosIcon
                  style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
                />
                <span
                  className="text-sm uppercase hidden lg:inline-block font-semibold"
                  style={{ color: "rgb(194 216 234)" }}
                >
                  ADD CUSTOMER
                </span>
              </div>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Customer Details
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="code"
                    >
                      Customer Code
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="code"
                      placeholder="code"
                      value={customer.code}
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.code}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="name"
                    >
                      Customer Name
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="name"
                      name="name"
                      value={customer.name}
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.name}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="contact"
                    >
                      Contact
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="contact"
                      name="contact"
                      value={customer.contact}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="phone"
                    >
                      Phone
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="phone"
                      name="phone"
                      value={customer.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-gray-400" />

              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Description
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="address"
                    >
                      Address
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="address"
                      name="address"
                      value={customer.address}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="town"
                    >
                      Town
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="town"
                      name="town"
                      value={customer.town}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="mail"
                    >
                      Mail
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="mail"
                      name="mail"
                      value={customer.mail}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="text-center flex justify-between">
                  <button
                    className="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    style={{
                      marginTop: "2rem",
                    }}
                    onClick={handleSubmit}
                  >
                    Edit Customer
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
